import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function LastAcceptedOfferBetween({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getLastOfferAcceptedBetween(query);
  const value =
    options.find((option) => !areObjectsDifferent(option.value, state)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setLastOfferAcceptedBetween(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Latest accepted offer"
      description="Filter by how long since the latest offer was accepted"
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: '1-7 days',
    value: {
      ToEndOfDay: true,
      To: days(-1),
      FromStartOfDay: true,
      From: days(-7),
    },
  },
  {
    label: '8-15 days',
    value: {
      ToEndOfDay: true,
      To: days(-8),
      FromStartOfDay: true,
      From: days(-15),
    },
  },
  {
    label: '16-45 days',
    value: {
      ToEndOfDay: true,
      To: days(-16),
      FromStartOfDay: true,
      From: days(-45),
    },
  },
];

function days(days: number) {
  return days * 24 * 60;
}

function setLastOfferAcceptedBetween(
  offset: Value
): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryLastAcceptedOfferAtOffset: offset,
  });
}

function getLastOfferAcceptedBetween(query: ace_index.FindInput) {
  return query.SummaryLastAcceptedOfferAtOffset;
}

type Value = ace_index.FindInput['SummaryLastAcceptedOfferAtOffset'];
